import React from "react";
import { Heading } from "@chakra-ui/react";

export const SectionHeading = ({ label }: { label: string }) => {
  return (
    <Heading as="h3"
             position="sticky"
             top="-3px"
             paddingY="l"
             borderBottomWidth="2px"
             borderBottomColor="grey.200"
             backgroundColor="white"
             zIndex="50"
             fontWeight="light"
             marginTop="l"
             marginBottom="xl"
             fontSize="xl">
      {label}
    </Heading>
  );
};
